export default "__VITE_ASSET__BdE5p71v__"